import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import {
  NewTransaction,
  StartTransaction,
  StartTransactionResponse,
  Worksite,
} from '../../types/Application/application';

export const formsApi = createApi({
  reducerPath: 'formsApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    newTransaction: builder.mutation<string, NewTransaction>({
      query: (data) => ({
        url: `/signing/newTransaction`,
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(data),
        cache: 'no-cache',
      }),
    }),
    cancelTransaction: builder.mutation<void, string>({
      query: (id) => ({
        url: `/signing/cancelTransaction?id=${id}`,
        method: 'POST',
      }),
    }),
    startTransaction: builder.mutation<
      StartTransactionResponse,
      StartTransaction
    >({
      query: (startTransaction) => ({
        url: `/signing/startTransaction`,
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: startTransaction,
      }),
    }),
    getTransaction: builder.query<StartTransactionResponse, string>({
      query: (id) => ({
        url: `/signing/getTransaction?id=${id}`,
        method: 'GET',
      }),
    }),
    getForaAssurance: builder.query<boolean, string>({
      query: (orgNumber) => `/forms/getForaAssurance?orgNumber=${orgNumber}`,
    }),
    getWorkSites: builder.query<Worksite[], string>({
      query: (orgNumber) => `/forms/getworksites?orgNumber=${orgNumber}`,
    }),
  }),
});

export const {
  useNewTransactionMutation,
  useStartTransactionMutation,
  useCancelTransactionMutation,
  useGetTransactionQuery,
  useLazyGetTransactionQuery,
  useGetForaAssuranceQuery,
  useLazyGetForaAssuranceQuery,
  useGetWorkSitesQuery,
  useLazyGetWorkSitesQuery,
} = formsApi;
